import { useCallback, useState, useMemo } from 'react';
import { OPEN_REMOVE_ATTACHMENT_MODAL, isLoading } from 'crm-events-data';
// @ts-expect-error Could not find a declaration file
import RemoveAttachmentModal from 'customer-data-email/components/attachments/RemoveAttachmentModal';
import { EngagementDependency } from 'crm-events-data';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Could not find a declaration file
import { updateEngagementAttachments } from 'crm_data/engagements/EngagementsActions';
import { Map as ImmutableMap } from 'immutable';
import { permanentlyDeleteFile, gdprDeleteFile
// @ts-expect-error Could not find a declaration file
} from 'crm_data/fileManager/FileManagerAPI';
// @ts-expect-error Could not find a declaration file
import { addDanger } from 'customer-data-ui-utilities/alerts/Alerts';
import Raven from 'raven-js';
// @ts-expect-error Could not find a declaration file
import { useStoreDependency } from 'general-store';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
export const useRemoveAttachmentModalActionHandler = (objectType, subjectId) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [engagementId, setEngagementId] = useState(null);
  const [attachmentToBeRemoved, setAttachmentToBeRemoved] = useState(null);
  const [shouldUseGdprDelete, setShouldUseGdprDelete] = useState(false);
  const [shouldPermanentlyDeleteAttachment, setShouldPermanentlyDeleteAttachment] = useState(false);
  const engagement = useStoreDependency(EngagementDependency, {
    engagementId
  });
  const initializeOpenModalState = useCallback(data => {
    setShouldUseGdprDelete(data.shouldUseGdprDelete);
    setEngagementId(data.engagementId);
    setAttachmentToBeRemoved(data.attachmentInfo);
    setIsModalOpen(true);
    setShouldPermanentlyDeleteAttachment(false);
  }, []);
  const handleRemoveAttachmentModalAction = useCallback((actionType, data) => {
    if (actionType === OPEN_REMOVE_ATTACHMENT_MODAL) {
      initializeOpenModalState(data);
    }
  }, [initializeOpenModalState]);
  const handleToggleShouldPermanentlyDeleteAttachment = useCallback(({
    target: {
      checked
    }
  }) => {
    setShouldPermanentlyDeleteAttachment(checked);
  }, []);
  const renderedModalDescription = useMemo(() => {
    const message = shouldUseGdprDelete ? 'attachmentOptions.gdprDeleteCheckboxDescription' : 'attachmentOptions.permanentlyDeleteCheckboxDescription';
    return /*#__PURE__*/_jsx(Checkbox, {
      onChange: handleToggleShouldPermanentlyDeleteAttachment,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      })
    });
  }, [handleToggleShouldPermanentlyDeleteAttachment, shouldUseGdprDelete]);
  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  const sendUpdateAttachmentsMessage = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_RECORD_ATTACHMENTS);
  const handleRemoveAttachmentFromEngagement = useCallback(() => {
    const updatedEngagementAttachments = engagement.get('attachments').filter(attachment => attachment.get('id') !== attachmentToBeRemoved.id);
    if (engagementId) {
      sendUpdateAttachmentsMessage({
        objectTypeId: normalizeTypeId(objectType),
        objectId: subjectId,
        engagementId
      });
    }
    return updateEngagementAttachments(engagement, ImmutableMap({
      attachments: updatedEngagementAttachments
    }));
  }, [attachmentToBeRemoved, engagement, engagementId, objectType, subjectId, sendUpdateAttachmentsMessage]);
  const handleRemoveAttachmentError = useCallback(error => {
    addDanger('attachmentOptions.deleteFailedAlert');
    Raven.captureException(error);
  }, []);
  const handleRemoveAttachment = useCallback(() => {
    handleCloseModal();
    if (!shouldPermanentlyDeleteAttachment) {
      return handleRemoveAttachmentFromEngagement().catch(handleRemoveAttachmentError);
    }
    if (shouldUseGdprDelete) {
      return gdprDeleteFile(attachmentToBeRemoved.id).then(handleRemoveAttachmentFromEngagement).catch(handleRemoveAttachmentError);
    }

    // delete file from file manager
    return permanentlyDeleteFile(attachmentToBeRemoved.id).then(handleRemoveAttachmentFromEngagement).catch(handleRemoveAttachmentError);
  }, [attachmentToBeRemoved, handleCloseModal, handleRemoveAttachmentError, handleRemoveAttachmentFromEngagement, shouldPermanentlyDeleteAttachment, shouldUseGdprDelete]);
  const renderedRemoveAttachmentModal = useMemo(() => {
    if (!attachmentToBeRemoved || isLoading(engagement)) {
      return null;
    }
    return /*#__PURE__*/_jsx(RemoveAttachmentModal, {
      attachmentName: attachmentToBeRemoved.name,
      description: renderedModalDescription,
      isOpen: isModalOpen,
      onCancelClick: handleCloseModal,
      onRemoveClick: handleRemoveAttachment
    });
  }, [attachmentToBeRemoved, engagement, handleCloseModal, handleRemoveAttachment, isModalOpen, renderedModalDescription]);
  return {
    handleRemoveAttachmentModalAction,
    removeAttachmentModal: renderedRemoveAttachmentModal
  };
};